import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 50%;
`;

export const InputWrapper = styled.div`
  grid-column: 1/-1;
`;
